export default "__VITE_ASSET__BrHOXVXE__"